<script setup lang="ts">
const reload = () => {
  window.location.reload();
};
</script>

<template>
  <div class="flex min-h-svh flex-col items-center justify-center px-4 py-16 text-center">
    <span class="flex size-20 items-center justify-center rounded-full bg-error/10 ring-8 ring-error/5">
      <UIcon
        name="i-lucide-server-crash"
        class="size-9 text-error"
      />
    </span>
    <h1 class="mt-7 text-2xl font-bold text-highlighted">
      Сервер не отвечает
    </h1>
    <p class="mt-2 max-w-sm text-base leading-relaxed text-toned text-balance">
      Запрос не дошёл до сервера или он ответил ошибкой. Попробуй перезагрузить страницу.
    </p>
    <UButton
      size="lg"
      color="primary"
      icon="i-lucide-refresh-cw"
      label="Перезагрузить страницу"
      class="mt-8"
      @click="reload"
    />
  </div>
</template>
